import { setHeight, getElementParents } from '../helpers/general';
import selectSiblings from '../helpers/siblings';

// MEGA MENU OPEN
document.querySelectorAll('.submenu .level-1 > ul > li.section, .submenu .level-1 > ul > li.current').forEach((currentLi) => {
  currentLi.classList.add('open');
  const subMenuHeight = currentLi.querySelector('.submenu')?.getBoundingClientRect().height;

  if (subMenuHeight > currentLi.parentNode.getBoundingClientRect().height) {
    getElementParents(currentLi, '.level-1').forEach((el) => {
      setHeight(el, subMenuHeight);
    });
  }
});

document.querySelectorAll('.toggle-mega-menu').forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();

    const currentListItem = toggle.parentNode;
    const aMegaMenuIsOpen = document.body.classList.contains('mega-menu-open');

    if (aMegaMenuIsOpen && currentListItem.classList.contains('open')) {
      document.body.classList.remove('mega-menu-open');
      document.querySelector('#nav-bar').style.zIndex = 999;
    } else {
      document.body.classList.add('mega-menu-open');
      document.querySelector('#nav-bar').style.zIndex = 9999;
    }

    document.querySelectorAll('#main-nav > ul > li.has-submenu').forEach((el) => {
      if (el === currentListItem) {
        return;
      }

      el.classList.remove('open');
    });

    toggle.parentNode.classList.toggle('open');
  });
});

// MEGA MENU CLOSE
document.querySelectorAll('.close-mega-menu').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();

    document.body.classList.remove('mega-menu-open');
    el.closest('.has-submenu').classList.toggle('open');
    document.querySelector('#nav-bar').style.zIndex = 999;
  });
});

// MEGA MENU SUBNAV
document.querySelectorAll('nav.level-1 .has-submenu > a').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();

    const subMenuLink = e.currentTarget;
    const subMenuLinkParent = subMenuLink.parentNode;
    const upperNav = getElementParents(subMenuLink, 'nav.level-1')[0];

    const subMenuLinkParentSiblings = selectSiblings(subMenuLinkParent);

    subMenuLinkParentSiblings.forEach((sibling) => {
      sibling.classList.remove('open');
    });

    subMenuLinkParent.classList.toggle('open');

    subMenuLinkParent.querySelectorAll('.has-submenu.open').forEach((openMenu) => {
      openMenu.classList.remove('open');
    });

    let currentHighestNav = 0;
    upperNav.querySelectorAll('.has-submenu.open > .submenu').forEach((submenu) => {
      const navHeight = submenu.getBoundingClientRect().height;

      if (navHeight > currentHighestNav) {
        currentHighestNav = navHeight;
      }
    });

    if (currentHighestNav > upperNav.querySelector('ul:first-of-type').getBoundingClientRect().height) {
      upperNav.style.height = currentHighestNav + 'px';
    } else {
      upperNav.style.height = 'auto';
    }
  });
});
